var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
import { Comp } from '../../models/component/component';
var FilterDirective = /** @class */ (function (_super) {
    __extends(FilterDirective, _super);
    function FilterDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.comp = new Comp();
        return _this;
    }
    FilterDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    FilterDirective.prototype.onInit = function () {
        _super.prototype.onInit.call(this);
        if (this.comp.params && this.comp.params.addClass) {
            var add = jsonpath.value(this.comp.params.addClass, '$.' + this.tag);
            if (add) {
                _super.prototype.addClass.call(this, add);
            }
        }
    };
    FilterDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[filterDir]'
                },] }
    ];
    /** @nocollapse */
    FilterDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    FilterDirective.propDecorators = {
        comp: [{ type: Input }]
    };
    return FilterDirective;
}(ClassBaseDirective));
export { FilterDirective };
//# sourceMappingURL=filter.directive.js.map